var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "product-flash",
    class: [("product-flash_" + (_vm.itemsCount))]
  }, _vm._l(_vm.items.slice(0, 5), function (item, index) {
    var _item$price, _item$image, _item$image2, _item$image3, _item$price2;

    return _c('div', {
      key: index,
      staticClass: "product-flash__item"
    }, [(_item$price = item.price) !== null && _item$price !== void 0 && _item$price.discount ? _c('ProductDiscountMarker', {
      staticClass: "product-flash__labels product-flash__labels_discount",
      attrs: {
        "price": item.price.discount.value,
        "discount": item.price.common.value
      }
    }) : _vm._e(), _vm._v(" "), _c('GGLink', {
      staticClass: "product-flash__wrap-img",
      attrs: {
        "to": item.path
      }
    }, [_c('img', {
      staticClass: "product-flash__img",
      attrs: {
        "src": (_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.x1,
        "srcset": ((_item$image2 = item.image) === null || _item$image2 === void 0 ? void 0 : _item$image2.x2) && (((_item$image3 = item.image) === null || _item$image3 === void 0 ? void 0 : _item$image3.x2) + " 2x"),
        "alt": item.name
      }
    })]), _vm._v(" "), item.name ? _c('GGLink', {
      staticClass: "product-flash__title",
      attrs: {
        "to": item.path
      }
    }, [_vm._v("\n      " + _vm._s(item.name) + "\n    ")]) : _vm._e(), _vm._v(" "), (_item$price2 = item.price) !== null && _item$price2 !== void 0 && _item$price2.common.value ? _c('GGPrice', {
      staticClass: "product-flash__price",
      attrs: {
        "price": item.price
      }
    }) : _vm._e(), _vm._v(" "), item.status && item.status.code !== 'NOT_AVAILABLE' ? _c('div', {
      staticClass: "product-flash__cart"
    }, [_c('CartTool', {
      attrs: {
        "item": _vm.userCartItem
      },
      on: {
        "add": function ($event) {
          return _vm.$emit('cart-add', item.id);
        },
        "remove": function ($event) {
          return _vm.$emit('cart-remove', item.id);
        }
      }
    }, [_c('span', [_vm._v(" В корзину ")])])], 1) : _vm._e()], 1);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }